import { requiredString } from 'src/utils/schemas';
import * as Yup from 'yup';

export const reportMissingQuoteAddressValidationSchema = Yup.object({
	postcode: requiredString,
	address: requiredString,
});
